export var LogType;
(function (LogType) {
    LogType[LogType["genericError"] = 1] = "genericError";
    LogType[LogType["noConnection"] = 2] = "noConnection";
    LogType[LogType["customError"] = 3] = "customError";
})(LogType || (LogType = {}));
